import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class UsersService {

  constructor(private globalService: GlobalService) {}

  add(data: any): Observable<any> {
    return this.globalService.post('/SP-CreateUsers/', data);
  }

  getAll(): Observable<any> {
    return this.globalService.get('/SP-GetAllUser/');
  }

  getById(id: string): Observable<any> {
    return this.globalService.get(`/SP-GetUserById/${id}`);
  }

  updateCredit(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateCreditUser/', data);
  }

  updateActivatedStop(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateActivatedStopUser/', data);
  }

  updateIsOn(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateIsOnUser/', data);
  }

  delete(data: any): Observable<any> {
    return this.globalService.post('/SP-DeleteUser/', data);
  }

  login(credentials: any): Observable<any> {
    return this.globalService.postLogin('/SP-Login/', credentials);
  }
}
